export default __webpack_public_path__ + "assets/777b01.png";